function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgLogoFacebook(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "uc-social"
  }, props), React.createElement("path", {
    fill: "#0A65FE",
    d: "M22 12.062C22 6.504 17.521 2 12 2 6.477 2 2 6.504 2 12.062c0 5.02 3.657 9.183 8.437 9.937v-7.03H7.899v-2.908h2.538V9.845c0-2.522 1.493-3.915 3.777-3.915 1.094 0 2.238.196 2.238.196v2.476h-1.26c-1.242 0-1.629.776-1.629 1.571v1.889h2.773l-.443 2.908h-2.33V22c4.78-.755 8.437-4.917 8.437-9.938z"
  }));
}

SvgLogoFacebook.clsName = 'icon-uc-social__logo-facebook';
SvgLogoFacebook.remarkName = 'unknown';
export default SvgLogoFacebook;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/uc-social/svgr/LogoFacebook.js
// module id = 2237
// module chunks = 17 18